import { createSlice } from "@reduxjs/toolkit";
import {
  getAllGiftCards,
  getGiftCardById,
  lookupGiftCard,
  purchaseGiftCard,
} from "../../services/giftCardService";
import toast from "../../utils/toast";

const initialState = {
  giftCards: null,  
  giftCard: null,    
  purchaseResult: null, 
  purchaseToken: null,
  loading: false,
};

const giftCardSlice = createSlice({
  name: "giftCard",
  initialState,
  reducers: {
     setPurchaseToken: (state, action) => {
      state.purchaseToken = action.payload;
    },
  },
  extraReducers: (builder) => {
    // ===== GET ALL =====
    builder.addCase(getAllGiftCards.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllGiftCards.fulfilled, (state, action) => {
      state.loading = false;
      if (Array.isArray(action.payload?.data)) {
        state.giftCards = action.payload.data;
      } else {
        state.giftCards = [];
      }
    });
    builder.addCase(getAllGiftCards.rejected, (state, action) => {
      state.loading = false;
      toast.error(action.payload || "Failed to fetch gift cards");
    });

    // ===== GET BY ID =====
    builder.addCase(getGiftCardById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getGiftCardById.fulfilled, (state, action) => {
      state.loading = false;
      state.giftCard = action.payload;
    });
    builder.addCase(getGiftCardById.rejected, (state, action) => {
      state.loading = false;
      state.giftCard = null;
      toast.error(action.payload || "Failed to fetch gift card details");
    });

    // gift card stripe 
    builder.addCase(purchaseGiftCard.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(purchaseGiftCard.fulfilled, (state, action) => {
      state.loading = false;
      state.purchaseResult = action.payload;
      toast.success("Gift card purchased successfully");
    });
    builder.addCase(purchaseGiftCard.rejected, (state, action) => {
      state.loading = false;
      state.purchaseResult = null;
      toast.error(action.payload || "Failed to purchase gift card");
    });
    // ===== LOOKUP BY SESSION ID =====
builder.addCase(lookupGiftCard.pending, (state) => {
  state.loading = true;
});
builder.addCase(lookupGiftCard.fulfilled, (state, action) => {
  state.loading = false;
  state.purchaseResult = action.payload;   
});
builder.addCase(lookupGiftCard.rejected, (state, action) => {
  state.loading = false;
  state.purchaseResult = null;
  toast.error(action.payload || "Failed to load purchase details");
});


  },
});
export const { setPurchaseToken } = giftCardSlice.actions;
export default giftCardSlice.reducer;
